import { render, staticRenderFns } from "./CanceledOrders.vue?vue&type=template&id=685e4b1d&scoped=true"
import script from "./CanceledOrders.vue?vue&type=script&lang=js"
export * from "./CanceledOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685e4b1d",
  null
  
)

export default component.exports